/* tslint:disable */
/* eslint-disable */
export enum ExceptionCode {
  MissingStep = 500,
  ReportConfigurationAlreadyExists = 501,
  InvitationAlreadyExists = 502,
  AccessDenied = 503,
  EntityAlreadyExists = 504,
  Error = 505,
  InvalidOperationToken = 506,
  InvalidValue = 507,
  SlotDisabled = 508,
  SapIntegrationError = 509,
  SapSlotNotFound = 510,
}
